/**
 * Local-calendar helpers for workspace exam_date (YYYY-MM-DD, never UTC/ISO).
 */

export const toLocalDateString = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

export const parseExamDate = (str) => {
  if (!str || typeof str !== 'string') return null;
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(str.trim());
  if (!match) return null;
  const y = Number(match[1]);
  const m = Number(match[2]);
  const d = Number(match[3]);
  return new Date(y, m - 1, d);
};

export const daysUntilExam = (str) => {
  if (!str) return null;
  const exam = parseExamDate(str);
  if (!exam) return null;

  const today = new Date();
  const todayMidnight = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );
  const examMidnight = new Date(
    exam.getFullYear(),
    exam.getMonth(),
    exam.getDate()
  );
  const msPerDay = 24 * 60 * 60 * 1000;
  return Math.round((examMidnight - todayMidnight) / msPerDay);
};

export const formatExamDate = (str) => {
  const date = parseExamDate(str);
  if (!date) return '';
  return date.toLocaleDateString('en-GB', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
};

/**
 * @returns {{ label: string, tooltip: string, tone: 'calm' | 'final' | 'passed' } | null}
 */
export const getExamCountdown = (str) => {
  const days = daysUntilExam(str);
  if (days === null) return null;

  const dateLabel = formatExamDate(str);

  if (days > 7) {
    return {
      label: `${days} days`,
      tooltip: `Exam on ${dateLabel}. Click to change.`,
      tone: 'calm',
    };
  }
  if (days >= 2) {
    return {
      label: `${days} days`,
      tooltip: `Exam on ${dateLabel}. Click to change.`,
      tone: 'final',
    };
  }
  if (days === 1) {
    return {
      label: '1 day',
      tooltip: 'Exam tomorrow. Click to change.',
      tone: 'final',
    };
  }
  if (days === 0) {
    return {
      label: 'Exam day',
      tooltip: 'Your exam is today. Good luck.',
      tone: 'final',
    };
  }
  return {
    label: 'Update date',
    tooltip: 'Your exam date has passed. Click to update.',
    tone: 'passed',
  };
};
